import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={22}
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.32032 8.18605H12.6797C12.6854 8.03505 12.6893 7.86304 12.6893 7.67443C12.6893 6.94403 12.631 5.98828 12.4074 5.0466C12.1828 4.10028 11.8046 3.22319 11.2027 2.58918C10.6197 1.97506 9.77691 1.53489 8.5 1.53489C7.22309 1.53489 6.38031 1.97506 5.79732 2.58918C5.19542 3.22319 4.81713 4.10028 4.59253 5.0466C4.36904 5.98828 4.31071 6.94403 4.31071 7.67443C4.31071 7.86304 4.3146 8.03505 4.32032 8.18605ZM14.1378 8.18605C14.143 8.03158 14.1464 7.86 14.1464 7.67443C14.1464 6.86994 14.0833 5.77917 13.8211 4.67434C13.5599 3.57414 13.0883 2.40472 12.233 1.50385C11.3589 0.583077 10.1373 0 8.5 0C6.86269 0 5.6411 0.583077 4.76697 1.50385C3.91172 2.40472 3.44001 3.57414 3.17889 4.67434C2.91668 5.77917 2.85357 6.86994 2.85357 7.67443C2.85357 7.86 2.85694 8.03158 2.86214 8.18605H2.67143C1.19603 8.18605 0 9.44592 0 11V19.1861C0 20.7402 1.19603 22 2.67143 22H14.3286C15.8039 22 17 20.7402 17 19.1861V11C17 9.44592 15.8039 8.18605 14.3286 8.18605H14.1378ZM4.36589 8.85907C4.3659 8.85918 4.36591 8.85918 4.36589 8.85907V8.85907ZM2.67143 9.72092C2.00079 9.72092 1.45714 10.2936 1.45714 11V19.1861C1.45714 19.8925 2.00079 20.4652 2.67143 20.4652H14.3286C14.9992 20.4652 15.5429 19.8925 15.5429 19.1861V11C15.5429 10.2936 14.9992 9.72092 14.3286 9.72092H2.67143Z"
      fill="#1F2A37"
    />
  </svg>
);

export default SVGComponent;
